import React, { useEffect, useState } from "react";
import { Sidebar } from "./components/Sidebar";
import { NavBar } from "./components/Navbar";
import { Full } from "./pages/full/Full";
import fetchData from "./functions/fetchData";
import { Dims } from "./pages/full/Dims";
import { TypeSelect } from "./TypeSelect";
import Form from "./form/Form";
import GearIcon from "./icons/GearIcon";
import Legs from "./pages/legs/Legs";
import Board from "./pages/board/Board";
import ShapePicker from "./ShapePicker";

export const Home = () => {
  const [rest, setRest] = useState({});
  const [legsMaterials, setLegsMaterials] = useState([]);
  const [legsModels, setLegsModels] = useState([]);
  const [boardMaterials, setBoardMaterials] = useState([]);
  const [boardParametters, setBoardParametters] = useState([]);
  const [dims, setDims] = useState([]);
  const [basePrice, setBasePrice] = useState({});
  const [price, setPrice] = useState(0);
  const [legPrice, setLegPrice] = useState(0);
  const [activeProduct, setActiveProduct] = useState({});
  const [overrideStep, setOverrideStep] = useState(null);
  const [visible, setVisible] = useState(false);
  const [formCode, setFormCode] = useState("");
  const [isActiveShape, setIsActiveShape] = useState(false);
  useEffect(() => {
    const fetchDataAsync = async () => {
      const REST = await fetchData();
      setRest(REST);
    };

    fetchDataAsync();
  }, []);
  useEffect(() => {
    setLegsModels(rest.legs_model);
    setLegsMaterials(rest.legs_materials);
    setBoardMaterials(rest.board_materials);
    setBoardParametters(rest.board_parametters);
    setDims(rest.complete_dims);
    setBasePrice(rest.prices);
    setFormCode(rest.configurator_form);
  }, [rest]);

  const [activeStep, setActiveStep] = useState(0);

  const handleNextStep = () => {
    setActiveStep((prev) => prev + 1);
    setOverrideStep(0);
  };
  return (
    <section className="configurator">
      <div className="configurator__spinner | js-spinner"></div>
      <div className={`configurator-sidebar ${visible ? "open" : ""}`}>
        <div className="configurator-sidebar__content">
          <div className="configurator-sidebar__content | js-configurator-sidebar">
            <Sidebar
              price={price}
              activeProduct={activeProduct}
              legPrice={legPrice}
              setVisible={setVisible}
              visible={visible}
            />
          </div>
        </div>
      </div>
      <div className="configurator__content">
        <div
          className="configurator__content-icon"
          onClick={() => {
            setVisible(true);
            document.body.classList.add("stop-scroll");
          }}
        >
          <GearIcon />
        </div>
        <NavBar activeStep={activeStep} setActiveStep={setActiveStep} />
        <div className="js-configurator-wrapper">
          <TypeSelect
            setActiveProduct={setActiveProduct}
            activeProduct={activeProduct}
            setNextStep={handleNextStep}
            setPrice={setPrice}
            setLegPrice={setLegPrice}
            isActive={activeStep == 0}
            setShape={setIsActiveShape}
          />
          {activeProduct.name == "full" && (
            <>
              <ShapePicker
                isActive={isActiveShape}
                setIsActive={setIsActiveShape}
                activeProduct={activeProduct}
                setActiveProduct={setActiveProduct}
              />
              <Dims
                isActive={activeStep == 1 && !isActiveShape}
                title={"Izaberite dimenzije - Komplet stola"}
                dims={dims}
                setNextStep={handleNextStep}
                activeProduct={activeProduct}
                setActiveProduct={setActiveProduct}
                setPrice={setPrice}
                setLegPrice={setLegPrice}
              />

              <Full
                isActive={activeStep == 2}
                boardMaterials={boardMaterials}
                boardParametters={boardParametters}
                legsModels={legsModels}
                legsMaterials={legsMaterials}
                activeProduct={activeProduct}
                setActiveProduct={setActiveProduct}
                basePrice={basePrice}
                setPrice={setPrice}
                overrideStep={overrideStep}
                setOverrideStep={setOverrideStep}
                setActiveStep={handleNextStep}
                setLegPrice={setLegPrice}
              />
              <Form
                price={price}
                legPrice={legPrice}
                isActive={activeStep == 3}
                activeProduct={activeProduct}
                formCode={formCode}
              />
            </>
          )}
          {activeProduct.name == "legs" && (
            <>
              <Dims
                isActive={activeStep == 1}
                title={"Izaberite dimenzije ploče"}
                dims={dims}
                setNextStep={handleNextStep}
                activeProduct={activeProduct}
                setActiveProduct={setActiveProduct}
                setPrice={setPrice}
                setLegPrice={setLegPrice}
              />
              <Legs
                isActive={activeStep == 2}
                overrideStep={overrideStep}
                setOverrideStep={setOverrideStep}
                setActiveStep={handleNextStep}
                legsModels={legsModels}
                legsMaterials={legsMaterials}
                activeProduct={activeProduct}
                setActiveProduct={setActiveProduct}
                setLegPrice={setLegPrice}
                notFull={true}
                basePrice={basePrice}
              />
              <Form
                price={price}
                legPrice={legPrice}
                isActive={activeStep == 3}
                activeProduct={activeProduct}
                formCode={formCode}
              />
            </>
          )}
          {activeProduct.name == "board" && (
            <>
              <ShapePicker
                isActive={isActiveShape}
                setIsActive={setIsActiveShape}
                activeProduct={activeProduct}
                setActiveProduct={setActiveProduct}
              />
              <Dims
                isActive={activeStep == 1 && !isActiveShape}
                title={"Izaberite dimenzije ploče"}
                dims={dims}
                setNextStep={handleNextStep}
                activeProduct={activeProduct}
                setActiveProduct={setActiveProduct}
                setPrice={setPrice}
                setLegPrice={setLegPrice}
              />
              <Board
                isActive={activeStep == 2}
                overrideStep={overrideStep}
                setOverrideStep={setOverrideStep}
                setActiveStep={handleNextStep}
                boardMaterials={boardMaterials}
                boardParametters={boardParametters}
                setPrice={setPrice}
                dims={dims}
                basePrice={basePrice}
                activeProduct={activeProduct}
                setActiveProduct={setActiveProduct}
              />
              <Form
                price={price}
                legPrice={legPrice}
                isActive={activeStep == 3}
                activeProduct={activeProduct}
                formCode={formCode}
              />
            </>
          )}
        </div>
      </div>
    </section>
  );
};
